/*
**  rui-record-detail-subheader.js
**
**  rui-record-detail-subheader component
*/
import { LitElement, html, css } from 'lit-element';
import { classMap } from 'lit-html/directives/class-map';
import { ruiIsDataDense } from '../common/rui-common-dom-detection.js';
export class RuiRecordDetailSubheader extends LitElement {
    static get is() {
        return 'rui-record-detail-subheader';
    }
    static get properties() {
        return {
            text: { type: String }
        };
    }
    constructor() {
        super();
        this.text = '';
    }
    render() {
        const classes = {
            ['rui-record-detail-subheader']: true,
            ['rui-record-detail-subheader-dense']: ruiIsDataDense()
        };
        return html `
            <div class="${classMap(classes)}">
                <div class="rui-record-detail-subheader-text">${this.text}</div>
                <div class="rui-record-detail-subheader-separator"></div>
            </div>
        `;
    }
    static get styles() {
        return css `
            :host {
                display: block;
                -webkit-font-smoothing: antialiased;
            }
            
            :host(:not(:first-child)) {
                margin-top: 25px;
            }
            
            .rui-record-detail-subheader {
                align-items: center;
                background: transparent;
                border-bottom-color: var(--line, #dbe4eb);
                color: var(--text-bright, #3c5c72);
                display: flex;
                font-size: 14px;
                font-weight: 600;
            }
            
            .rui-record-detail-subheader-dense {
                font-size: 13px;
            }
            
            .rui-record-detail-subheader-text {
                background-color: var(--content-primary-bg, #fff);
                flex: auto 0 0 ;
                padding-right: 18px;
                max-width: 100%;
            }
            
            .rui-record-detail-subheader-separator {
                background-color: var(--line, #dbe4eb);
                flex: 1 0 0%;
                width: 100%;
                height: 1px;
            }
       
            @media print {
                .rui-record-detail-subheader {
                    color: #000000;
                }
                .rui-record-detail-subheader-text {
                    background-color: #ffffff;
                }
            }
        `;
    }
}
customElements.get(RuiRecordDetailSubheader.is) || customElements.define(RuiRecordDetailSubheader.is, RuiRecordDetailSubheader);
